import { ModalTiteledWindow } from "./modalWindow.js";
import {DateSelect} from "../dateSelect.js";

//import "./extend/dom.js";
export class ModalSelectDate extends ModalTiteledWindow {
    constructor(options) {
        super();
        this.elMain = HTMLElement.createFromHTML('<div class="modal-select-date"></div>');
        this.elDate = this.elMain.querySelector('.date');

        let x = options.onSelect;
        options.onSelect = (date) => {
            x(date);
            this.close();
        };
        this.dateSelect = new DateSelect(options);
        this.elMain.appendChild(this.dateSelect.getElement());

        this.appendToBody(this.elMain);
        setTimeout(() => this.show(), 1);
    }

    setDate(from, to) {
        this.dateSelect.select(from, to);
    }

}
